import * as angular from 'angular';

import { Constants as constants } from '@constants/shared';
import { UsersRepo } from '@services/users.repo';
import { AddressListDialog } from '@app/bulkemailing/components/addressList.dialog';
import { emailDetailsDialog } from '@app/bulkemailing/components/emailDetails.dialog';
import { EmailRepo } from '@services/email.repo';
import { createEmail } from '@app/bulkemailing/views/createEmail';
import { emails } from '@app/bulkemailing/views/emails';


export const bulkEmailingModule = 'bulkEmailing';

/** Wires native file input change to createEmail's controller — no DOM queries or $postLink. */
function bulkEmailFilePickerDirective(): angular.IDirective {
  return {
    restrict: 'A',
    link(scope: angular.IScope, element: angular.IAugmentedJQuery) {
      const handler = () => {
        const input = element[0] as HTMLInputElement;
        const ctrl = (scope as any).$ctrl;
        if (ctrl && typeof ctrl.setAttachmentFiles === 'function') {
          ctrl.setAttachmentFiles(input.files);
        }
        // Allow re-selecting the same file(s) after removing or adding again
        input.value = '';
        scope.$applyAsync();
      };
      element.on('change', handler);
      scope.$on('$destroy', () => element.off('change', handler));
    }
  };
}

angular
  .module(bulkEmailingModule, [])
  .constant("config", constants.Default)
  .service('usersRepo', UsersRepo)
  .service('emailRepo', EmailRepo)
  .component('emails', emails)
  .component('createEmail', createEmail)
  .component('addressListDialog', AddressListDialog)
  .component('emailDetailsDialog', emailDetailsDialog)
  .directive('bulkEmailFilePicker', bulkEmailFilePickerDirective)



// WEBPACK FOOTER //
// ./src/app/bulkemailing/bulkemailing.index.ts